import { ErrorMessage } from "formik";
import useRTLContext from "../../hooks/useRTLContext";
import { useTranslation } from "react-i18next";

export default function CustomErrorMessage({ errors, touched, name }) {
  const error = errors[name];
  const isTouched = touched[name];
  const { isRTL, direction } = useRTLContext();
  const { t, i18n } = useTranslation();

  // Handle errors for FieldArray with simple array values (e.g., productColours)
  if (
    Array.isArray(error) &&
    Array.isArray(isTouched) &&
    typeof error[0] === "string"
  ) {
    return (
      <div style={{ fontSize: "14px", color: "red" }}>
        {error.map((fieldError, index) =>
          isTouched[index] ? (
            <div key={index}>
              {t("Row {{index}}: {{error}}", {
                index: index + 1,
                error: t(fieldError),
              })}
            </div>
          ) : null
        )}
      </div>
    );
  }

  // Handle errors for FieldArray with array of objects (e.g., additionalDetails, additionalCharges)
  if (Array.isArray(error) && Array.isArray(isTouched)) {
    return (
      <div style={{ fontSize: "14px", color: "red" }}>
        {error.map((fieldError, index) => (
          <div key={index}>
            {Object.entries(fieldError).map(([key, value]) => {
              return (
                isTouched[index]?.[key] && (
                  <div key={key}>
                    {t("Row {{index}} - {{field}}: {{error}}", {
                      index: index + 1,
                      field: t(key.charAt(0).toUpperCase() + key.slice(1)),
                      error: t(value),
                    })}
                  </div>
                )
              );
            })}
          </div>
        ))}
      </div>
    );
  }

  // Handle simple field errors (non-array)
  return (
    error &&
    isTouched && (
      <span
        className="text-danger"
        style={{
          fontSize: "14px",
          marginBottom: "3px",
          whiteSpace: "normal",
          wordWrap: "break-word", // Ensures long words break
          overflowWrap: "break-word", // Ensures proper word wrapping
          display: "block", // Ensures the span takes full width
          maxWidth: "100%", // Prevents going outside the container
        }}
      >
        <ErrorMessage name={name} render={(msg) => t(msg)} />
      </span>
    )
  );
}
